// Website display switches on the internal Companies page (API migration 0142).
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { companyWebsiteDisplayApi, type WebsiteDisplayPatch } from 'services'

const STATUS_KEY = ['internal', 'companies', 'website-display'] as const

/** One small map for the whole list (companies with a recorded member terms acceptance). */
export const useWebsiteDisplayStatus = (enabled = true) =>
  useQuery({
    queryKey: STATUS_KEY,
    queryFn: () => companyWebsiteDisplayApi.status(),
    staleTime: 60 * 1000,
    retry: false,
    enabled,
  })

export const useSetCompanyWebsiteDisplay = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ companyId, patch }: { companyId: string; patch: WebsiteDisplayPatch }) =>
      companyWebsiteDisplayApi.update(companyId, patch),
    onSuccess: () => {
      // The switches live on the company row, so the list is what goes stale.
      qc.invalidateQueries({ queryKey: ['companies', 'list'] })
      qc.invalidateQueries({ queryKey: STATUS_KEY })
    },
  })
}
